// extracted by mini-css-extract-plugin
export default {"outcomeGauge":"ghmVurmYpwYUIr9PA568","arcs":"kKYFBBw6g3z5F3PTeUPc","outcomeText":"QvNjvpLafr8YrkEx93hF","defaultColor":"xTE7rlFSIRRL14gUs25y"};